export const DEFAULT_CURRENCY = 'EUR' as const;
export const DEFAULT_QUANTITY = 1;
export const DEFAULT_SEGMENT = 'B2C' as const;
export const NO_COMMITMENT = 'no commitment' as const;

const NO_COMMITMENT_VALUES = new Set([
    '999',
    'be-isipareigojimu',
    'beisipareigojimu',
    'nbo',
    'no-commitment',
    'nocommitment',
    'withoutcommitment',
]);

export const normalizeSegment = (segment?: string): string => (segment || DEFAULT_SEGMENT).toUpperCase();

export const normalizeNumber = (value?: string | number): number => {
    if (typeof value === 'number') {
        return value || 0;
    }

    const numericValue = value
        ?.match(/-?\d+(?:[\s.,]\d+)*/)?.[0]
        ?.replace(/\s/g, '')
        .replace(',', '.');

    return Number(numericValue) || 0;
};

export const normalizeCommitmentType = (commitmentType?: string | number): string => {
    const value = String(commitmentType ?? '').trim();
    const normalizedValue = value.toLowerCase().replace(/\s+/g, '');

    if (!normalizedValue || NO_COMMITMENT_VALUES.has(normalizedValue)) {
        return NO_COMMITMENT;
    }

    const months = Number(value.match(/\d+/)?.[0]);

    return months ? `${months} months` : NO_COMMITMENT;
};
